// STARSEED-CAPMARKETS-066 — register-page draft persistence + error copy.
//
// The submit → Stripe Checkout redirect unmounts the SPA, so a member bounced
// back from the payment step (card declined, bank block, closed tab) used to
// land on a blank form and re-type everything ("had to start over again with
// no info", George, 2026-07-21). The draft keeps the non-sensitive fields
// per-tab across that round-trip. Passwords are deliberately NEVER stored.

export const DRAFT_KEY = "register_draft_v1";

const DRAFT_FIELDS = ["email", "full_name", "phone", "role", "referral_code", "sms_opt_in", "promo_code"];

export const loadDraft = () => {
  try {
    const raw = sessionStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    const d = JSON.parse(raw);
    return d && typeof d === "object" && !Array.isArray(d) ? d : null;
  } catch {
    return null;
  }
};

export const saveDraft = (formData) => {
  try {
    const draft = {};
    for (const k of DRAFT_FIELDS) draft[k] = formData[k];
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
  } catch {
    /* storage unavailable — restoring is best-effort */
  }
};

export const clearDraft = () => {
  try {
    sessionStorage.removeItem(DRAFT_KEY);
  } catch {
    /* best-effort */
  }
};

// The 503 off-gate shape ({success:false, reason:"stripe_not_enabled"},
// localdev-004c) carries no `detail`, so without mapping the member sees
// axios' raw "Request failed with status code 503" — George's exact knockout
// on 2026-07-21. Translate API failures into actionable copy.
export const registrationErrorMessage = (error) => {
  const data = error.response?.data;
  // Copy note (Copilot, #2163): a failed submit never navigates away, so
  // "still here on this page" describes the mounted form itself — accurate
  // even when sessionStorage persistence is unavailable.
  if (data?.reason === "stripe_not_enabled" || error.response?.status === 503) {
    return "Our payment processor is temporarily unavailable. Everything you entered is still here on this page — please try again in a few minutes, or contact your introducer if this persists.";
  }
  if (data?.detail) return data.detail;
  if (!error.response) return "We couldn't reach the server. Everything you entered is still here on this page — check your connection and try again.";
  return error.message || "Registration failed";
};
